<template>
  <div class="container shader">
    <Navbar v-if="!store.active_org"></Navbar>
    <NewOrg v-if="store.action == 'neworg'"></NewOrg>
    <ActiveOrg v-if="store.active_org"></ActiveOrg>
    <OrgList v-if="!store.active_org"></OrgList>
  </div>
</template>
<script setup>
import Navbar from "@/components/navbar/NavBar";
import NewOrg from "../components/org/NewOrg.vue";
import ActiveOrg from "../components/org/ActiveOrg.vue";
import OrgList from "../components/org/OrgList.vue";
import { auth, db } from "../firebase/config";
import { useStore } from "@/store/index";
import { doc, onSnapshot, setDoc, updateDoc } from "firebase/firestore";
import { ref, onMounted, onBeforeUnmount, watchEffect } from "vue";
const store = useStore();
var unsub;
onMounted(() => {
  fetchUserDataAndAddToStore();
  //console.log("Current user:", auth.currentUser.uid);
});
onBeforeUnmount(() => {
  unsub();
});
const fetchUserDataAndAddToStore = () => {
  unsub = onSnapshot(doc(db, "users", auth.currentUser.uid), async (docy) => {
    if (docy.data()) {
      store.setUserData(docy.data().settings);
    } else {
      var userObj = {
        settings: {
          active_org: "",
          org_name: "",
          active_account: "",
          start_date: "",
          end_date: "",
        },
      };
      await setDoc(doc(db, "users", auth.currentUser.uid), userObj);
    }
  });
};
</script>
<style scoped>
.shader {
  height: 100vh;
  background: linear-gradient(to bottom right, #ffffe4, #ffffff);
}
</style>
